import { AuthorizationLetterConfig } from "../../authorizationLetterConfiguration";
import AuthorizationLetterFieldSection from "../authorizationLetterFieldSection/authorizationLetterFieldSection";

interface AuthorizationLetterConfigFormProps {
  config: AuthorizationLetterConfig;
  onFieldChange: (
    fieldName: keyof AuthorizationLetterConfig,
    value: any,
  ) => void;
}

const AuthorizationLetterConfigForm = ({
  config,
  onFieldChange,
}: AuthorizationLetterConfigFormProps) => {
  return (
    <div className="flex-1 overflow-y-auto">
      <div className="flex flex-col gap-6 p-4">
        {/* Approval Keywords Section */}
        <AuthorizationLetterFieldSection
          title="Approval Keywords"
          fieldKey="approval_keywords"
          values={config.approval_keywords?.sort() || []}
          onValuesChange={(values) =>
            onFieldChange("approval_keywords", values)
          }
        />

        {/* Denial Keywords Section */}
        <AuthorizationLetterFieldSection
          title="Denial Keywords"
          fieldKey="denial_keywords"
          values={config.denial_keywords?.sort() || []}
          onValuesChange={(values) => onFieldChange("denial_keywords", values)}
        />

        {/* Negation Keywords Section */}
        <AuthorizationLetterFieldSection
          title="Negation Keywords"
          fieldKey="negation_keywords"
          values={config.negation_keywords?.sort() || []}
          onValuesChange={(values) =>
            onFieldChange("negation_keywords", values)
          }
        />

        {/* LOINC Code Section */}
        <AuthorizationLetterFieldSection
          title="LOINC Code"
          fieldKey="loinc_code"
          values={config.loinc_code || []}
          onValuesChange={(values) => onFieldChange("loinc_code", values)}
        />

        {/* Lookback Days Section */}
        <div className="rounded-lg border border-primaryGray-14 p-4">
          <div className="mb-3 text-sm font-semibold text-primaryGray-1">
            Lookback Days
          </div>
          <input
            type="number"
            value={config.lookback_days ?? 90}
            onChange={(e) =>
              onFieldChange("lookback_days", Number(e.target.value))
            }
            className="w-full rounded border border-primaryGray-14 bg-white px-3 py-2 text-sm text-primaryGray-1 focus:border-primaryGray-1 focus:outline-none"
            min="0"
          />
        </div>

        {/* Resource Type Text Section */}
        <div className="rounded-lg border border-primaryGray-14 p-4">
          <div className="mb-3 text-sm font-semibold text-primaryGray-1">
            Resource Type Text
          </div>
          <input
            type="text"
            value={config.resource_type_text ?? ""}
            onChange={(e) =>
              onFieldChange("resource_type_text", e.target.value)
            }
            className="w-full rounded border border-primaryGray-14 bg-white px-3 py-2 text-sm text-primaryGray-1 focus:border-primaryGray-1 focus:outline-none"
            placeholder="Enter resource type text"
          />
        </div>

        {/* Enabled Toggle Section */}
        <div className="rounded-lg border border-primaryGray-14 p-4">
          <div className="mb-3 text-sm font-semibold text-primaryGray-1">
            Enabled
          </div>
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={config.enabled ?? true}
              onChange={(e) => onFieldChange("enabled", e.target.checked)}
              className="h-4 w-4 cursor-pointer accent-black"
            />
            <span className="text-sm text-primaryGray-1">
              Enable authorization letter configuration
            </span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default AuthorizationLetterConfigForm;
